<div class="tt-guideline-note-dialog_description">
  {{ data.title | transloco }}
</div>
<div class="tt-guideline-note-dialog_message">
  <common-rich-text-view [content]="data.message" />
</div>
<div class="tt-guideline-note-dialog_footer">
  <div class="tt-guideline-note-dialog_footer-info">
    @if (data.infoData.version; as version) {
      <span>{{ 'Version' | transloco }}:&nbsp;</span>
      {{ data.infoData.version }}&nbsp;
    }
    @if (data.infoData.approvedAt) {
      {{ 'NoteDialog.ApprovedAt' | transloco }}: {{ data.infoData.approvedAt }}&nbsp;
    }
    @if (data.infoData.approvedBy?.firstName && data.infoData.approvedBy?.lastName) {
      {{ data.options?.publisherKey ?? 'NoteDialog.ApprovedBy' | transloco }}: {{ data.infoData.approvedBy | name }}
    }
  </div>
</div>
